"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATEADD = void 0;
const tab_1 = require("../../../tab");
exports.DATEADD = {
    description: 'Adds the {amount} parameter to the column value {interval}',
    arg_names: ['date_to_add', 'interval', 'amount'],
    args_def: [
        {
            types: ['date'],
            required: true,
        },
        {
            types: ['enum(DAY | MONTH | YEAR | HOUR | MINUTE | SECOND)'],
            required: true,
        },
        {
            types: ['number'],
            required: true,
        },
    ],
    args_description: [
        'date to be incremented',
        'enumerator indicating what interval type should be incremented',
        'amount to increment',
    ],
    return_type: tab_1.ColumnType.DATE,
};
